const state = {
    type: null,
    message: null,
    dismissible: false,
    show: true,
    icon: true
};

const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    gift({ commit }, message) {
        commit('gift', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    info({ commit }, message) {
        commit('info', message);
    },
    clear({ commit }) {
        commit('clear');
    }
};

const mutations = {
    success(state, message) {
        state.type = 'success';
        state.message = message;
        state.dismissible = true;
        state.show = true;
        state.icon = true
    },
    gift(state, message) {
        state.type = 'success';
        state.message = message;
        state.dismissible = true;
        state.show = true;
        state.icon = 'mdi-gift'
    },
    error(state, message) {
        state.type = 'error';
        state.message = message;
        state.dismissible = true;
        state.show = true;
        state.icon = true
    },
    info(state, message) {
        state.type = 'info';
        state.message = message;
        state.dismissible = true;
        state.show = true;
        state.icon = true
    },
    clear(state) {
        state.type = null;
        state.message = null;
        state.show = true;
        state.icon = true
    }
};

export const alert = {
    namespaced: true,
    state,
    actions,
    mutations
};
